import * as Yup from "yup";
import { MedicalCodeFormTypeEnum, RoleTypeEnum } from "../services";
export type LoinCodeCatalogInitialValuesType = {
  loinc_code: string;
  description: string;
};

export const LOIN_CODE_CATALOG_INITIAL_VALUES: LoinCodeCatalogInitialValuesType =
  {
    loinc_code: "",
    description: "",
  };


export type diagnosticCodeCatalogInitialValuesType = {
  codeVersion?: "ICD 09" | "ICD 10" | "ICD 11";
  icd_code: string;
  description: string;
};

export const DIAGNOSTIC_CODE_CATALOG_INITIAL_VALUES: diagnosticCodeCatalogInitialValuesType =
  {
    codeVersion: undefined,
    icd_code: "",
    description: "",
  };

export type cptCodeCatalogInitialValuesType = {
  cpt_code: string;
  description: string;
};

export const CPT_CODE_CATALOG_INITIAL_VALUES: cptCodeCatalogInitialValuesType =
  {
    cpt_code: "",
    description: "",
  };

export type hcpcsCodeCatalogInitialValuesType = {
  hcpcs_code: string;
  description: string;
};

export const HCPCS_CODE_CATALOG_INITIAL_VALUES: hcpcsCodeCatalogInitialValuesType =
  {
    hcpcs_code: "",
    description: "",
  };

export type DrugCodeCatalogFormType = {
  drugId?: string;
  strength?: string;
  drugName?: string;
  formType?: MedicalCodeFormTypeEnum;
  description?: string;
  code: string;
};

export const ADD_DRUG_CODE_CATALOG_INITIAL_VALUES: DrugCodeCatalogFormType = {
  drugId: "",
  formType: undefined,
  drugName: "",
  strength: "",
  description: "",
  code: "DRUG_CATALOG",
};

export type RoleFormik = {
  id: undefined;
  name: string;
  type?: { value: RoleTypeEnum; label: string };
  description?: string;
};

export const VIEW_PROFILE_INITIAL_VALUES: RoleFormik = {
  id: undefined,
  name: "",
  type: undefined,
  description: "",
};

const ROLE_NAME_VALIDATION = {
  ALLOWED_PATTERN: /^[a-zA-Z\s]+$/,
  FORBIDDEN_CHARS: {
    HYPHENS: /-/g,
    NUMBERS: /[0-9]/g,
    UNDERSCORES: /_/g,
    SPECIAL_SYMBOLS: /[!@#$%^&*()+=[\]{}|;:'"<>?,./~`]/g,
  },
  ERROR_MESSAGE:
    "Role name can only contain letters and spaces. Please remove any numbers, hyphens, underscores, or special characters.",
};

export const VIEW_EDIT_PROFILE_VALIDATION_SCHEMA = Yup.object({
  name: Yup.string()
    .required()
    .trim()
    .matches(
      ROLE_NAME_VALIDATION.ALLOWED_PATTERN,
      ROLE_NAME_VALIDATION.ERROR_MESSAGE
    )
    .label("Role Name"),
  type: Yup.object().required().label("Role Type"),
});
